import "./CodeInput.css";

// src/components/inputs/CodeInput.js
import Editor from "@monaco-editor/react";
import PropTypes from "prop-types";
import React from "react";

const CodeInput = ({ label, value, onChange, height = "200px" }) => {
  const safeId = `code-input-${label.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div className="mb-6 p-2">
      <label htmlFor={safeId} className="block mb-2 font-bold text-gray-500">
        {label}
      </label>
      <Editor
        defaultLanguage="html"
        theme="vs-light"
        height={height}
        value={value}
        onChange={(val) => onChange(val)}
        options={{
          automaticLayout: true,
          fontSize: 14,
          minimap: { enabled: false },
        }}
        className="border border-gray-300 rounded"
        style={{ fontFamily: "Fira Code" }}
      />
    </div>
  );
};

CodeInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  height: PropTypes.string,
};

export default CodeInput;
